import React from "react";
import PropTypes from "prop-types";
import { Alert, Button } from "@mui/material";

/**
 * Distinct error UI for failed clinical/patient data fetches.
 * Never show an empty-list message alongside this: a failed load is not "none".
 */
export default function DataLoadErrorAlert({
  message,
  onRetry,
  sx,
  severity = "error",
}) {
  return (
    <Alert
      severity={severity}
      sx={{ mb: 2, ...sx }}
      action={
        typeof onRetry === "function" ? (
          <Button color="inherit" size="small" onClick={onRetry}>
            Retry
          </Button>
        ) : null
      }
    >
      {message || "Unable to load this information. Please retry."}
    </Alert>
  );
}

DataLoadErrorAlert.propTypes = {
  message: PropTypes.string,
  onRetry: PropTypes.func,
  sx: PropTypes.object,
  severity: PropTypes.string,
};
